// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentName } from '@shared/enum';

export const environment = {
  production: false,
  name: EnvironmentName.DEV,
  basePath: 'https://api.ambassades.mlkdev.net',
  baseURLPath: 'http://local.ambassades.eglisemlk.fr:4200/#/mlk',
  donationProductName: 'don-ponctuel-ambassades',
  ponctualDonationProductName: 'don-ponctuel-ambassades',
  monthlyDonationProductName: 'don-recurrent-ambassades',
  paymentbaseURL: 'https://payment.dev.eglisemlk.fr',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
